import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { take, takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { DataCenterProcess } from "src/app/gnr/data-center-process/data-center-process.model";
import { ZoneFormComponent } from "./zone-form.component";
@Component({
  selector: "ngx-city-list",
  template: `<div class="page" style="height:100%; padding:3vmin; background: var(--bg-primary);">
    <kgrid
      [apiName]="apiName"
      [noAutoFitColumns]="true"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      defaultSortKey="Code"
      reportName="Zone"
      pathPreFix="SALE"
      [isMulti]="true"
      [IgnoreDeletePermission]="IgnoreDelete"
      [deleteMessage]="deleteMessage"
      [unSortableFilterable]="unSortableFilterable"
      [inputEditorform]="inputEditorform"
      [isAdd]="isAdd"
      [isEdit]="isEdit"
      [isDelete]="isDelete">
    </kgrid>
  </div>`,
})
export class ZoneListComponent extends BaseListComponent {
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  unSortableFilterable: string[] = [];
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;

  constructor() {
    super();
    this.inputEditorform = ZoneFormComponent;
    this.FillData();
  }

  ngOnInit() {
    this.apiName = "Zone";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Parties.Zone.Zone");
    this.unSortableFilterable.push("IsActive");
    this.unSortableFilterable.push("ShippingCost");
    this.unSortableFilterable.push("CourierShippingCost");
    this.unSortableFilterable.push("MinutesToDelivery");
    this.unSortableFilterable.push("IsFreeDelivery");
    this.unSortableFilterable.push("MinimumPurchaseForFreeShipping");
  }

  async FillData() {
    const currentBranch = this.accountService.authService.currentInformation();
    if (currentBranch.BranchingLightEnabled || currentBranch.BranchingAdvancedEnabled || currentBranch.RestaurantCallCenter) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/Locations")
        .pipe(take(1))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (!this.accountService.authService.currentBranch.AccessToAllBranches && hbc.BranchCount != 1) {
            this.isAdd = false;
            this.isEdit = true;
            this.isDelete = false;
          }
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.FrontOffice.Parties.Zone.HasBranchCommunication");
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.IgnoreDelete = true;
                this.deleteMessage = this.translate("ClientApp.FrontOffice.Parties.Zone.HasCallCenterCommunication");
                return;
              }
            }
          }
        });
    }
  }
}
